import * as React from "react";
import type { SVGProps } from "react";

const SvgPastPurchases = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="nonzero"
      d="M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 1.463A8.527 8.527 0 0 1 18.537 10 8.527 8.527 0 0 1 10 18.537 8.527 8.527 0 0 1 1.463 10 8.527 8.527 0 0 1 10 1.463m0 1.22a.73.73 0 0 0-.732.732V10c0 .27.148.506.366.633l5.282 3.048a.73.73 0 1 0 .732-1.265l-4.916-2.835V3.415A.73.73 0 0 0 10 2.683"
    />
  </svg>
);
export default SvgPastPurchases;
